import BeyondBlue from "../../img/health-organization/BeyondBlue.png";
import Lifeline from "../../img/health-organization/Lifeline.png";
import RuralAids from "../../img/health-organization/RuralAids.png";
import CanadaSuicidePrevention from "../../img/health-organization/CanadaSuicidePrevention.png";

export const healthSupportConfig = {
  Australia: [
    {
      logo: BeyondBlue,
      name: 'Beyond Blue',
      phoneNumber: '1300 22 4636',
    },
    {
      logo: Lifeline,
      name: 'Lifeline',
      phoneNumber: '13 11 14',
    },
    {
      logo: RuralAids,
      name: 'Rural Aids',
      phoneNumber: '1300 327 624',
    },
  ],
  Canada: [
    {
      logo: CanadaSuicidePrevention,
      name: 'Canada Suicide Prevention Service',
      phoneNumber: '1833 456 4566',
    },
  ],
};
